import { Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import { TableTD } from 'dashboard/layouts/TableLayout';
import { TableRow } from 'design-system/components/Table';
import { Label, Paragraph } from 'design-system/components/Text';
import { isHovered } from 'design-system/lib/pseudoClass';

/**
 * InquiryTemplateConfigEditor card description shared styles
 */
export const SectionDescription = styled(Paragraph).attrs(() => ({ size: 'md' }))`
  color: ${({ theme }) => theme.color.text.tertiary};
  margin-bottom: ${Spacing[4]};
  white-space: pre-wrap;
`;

/**
 * TableSubRow nested within accordions in FLE/VTE table views. Removes default TableRow hover highlight behavior.
 */
export const TableSubRow = styled(TableRow)`
  &${isHovered} {
    background-color: transparent;
  }
`;

/**
 * td spanning the width of the table to house single element rows such as attribute override fields and accordions
 */
export const FullSpanSubRowTD = styled('td').attrs((props) => ({ colSpan: props.colSpan || 2 }))<{
  colSpan?: number;
  isLast?: boolean;
}>`
  padding: 0px ${Spacing[4]} ${Spacing[4]} ${Spacing[4]};
  ${({ isLast }) =>
    isLast &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
    `}
`;

/**
 * sub row TD with padding + removed bottom border
 */
export const SubRowLabelTD = styled(TableTD)`
  border-bottom: none;
  padding: ${Spacing[1]} ${Spacing[1]} ${Spacing[1]} ${Spacing[4]};
`;

/**
 * field wrapper removing the bottom margin from FormGroup
 */
export const FieldWrapper = styled(FormGroup)`
  margin-bottom: 0px;
  > div:first-child {
    margin-bottom: 0px;
  }
`;

export const SubRowLabel = styled(Label).attrs(() => ({ size: 'md', weight: 'bold' }))`
  font-weight: ${({ theme }) => theme.text.paragraph.md.fontWeight};
`;
